import React, { Component } from 'react';
import parse from 'html-react-parser';
import { Container, Tabs, Tab, Button } from 'react-bootstrap';
import { FaPlus, FaPen, FaFileLines, FaToggleOn, FaToggleOff, FaStar, FaRegStar, FaChevronRight, FaTrash } from "react-icons/fa6";

// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import DescriptionIcon from '@mui/icons-material/Description';
// import AddIcon from '@mui/icons-material/Add';
// import ToggleOnIcon from '@mui/icons-material/ToggleOn';
// import ToggleOffIcon from '@mui/icons-material/ToggleOff';
// import StarIcon from '@mui/icons-material/Star';
// import StarBorderIcon from '@mui/icons-material/StarBorder';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import MenuLeftCMS from './ct-fragmentsidemenu';
import { GetText, ReplaceOutputTextHTML } from '../config/helper';
import DateTimeFormats from '../config/date-time-format';
import '../config/global';
import CTNA from './ct-fragmentna';


const authKey = global.config.kindcode.training[2]+global.config.authBearerKey;

export default class CTLibrary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activelink:"none",
      pageShow: '10',
      keyword: '',
      data: {"ENG": [], "IDN": []},
      defTabIndex: "",
      usageFor: '',
    }
    this.loadContent = this.loadContent.bind(this);
    this.loadData = this.loadData.bind(this);
  }
  handleChange(e) {
    this.setState({ [e.target.name] : e.target.value });
  }
  handleUserSelect = (e) => {
    const value = e.target.value;
    this.setState( prevState => {
        return {  
            ...prevState.pageShow, pageShow: value
        }
    })
  }
  urladdCourse(currpage,param) {
    // var path = "english";
    // if(param === "idn") { path = "indonesia"; }
    // window.location.href=global.config.urlCms+"/"+currpage+"/"+path+'/add';
    window.location.href=global.config.urlCms+"/"+currpage+'/add/'+param;
  }
  urlpublishCourse(valId,nextstat,param) {
    document.getElementById('loading-area').style.display = 'block'; 
    var usedfor = "english"; if(param === 'IDN') { usedfor = "indonesia"; }
    var datatext ='{"course_docid":"'+valId+'","course_status":"'+nextstat+'","form_id":"form-publish"}';
    var data = JSON.parse(datatext); 
    var urlFetch = global.config.urlLink+"/courseedit";
    fetch(urlFetch, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
        }).then(res => {
            if(res.status === 200) return res.json() 
        }).then( resJson => {
            document.getElementById('loading-area').style.display = 'none'; 
            if(resJson.status === '200') {
                window.location.href=global.config.urlCms+"/"+this.state.activelink+"/"+usedfor;
            } else {
                console.log('Something happened wrong');
            }
        }).catch(err => { 
            document.getElementById('loading-area').style.display = 'none'; 
        });
  }
  urlfeaturedCourse(valId,isFeatured,param) {
    document.getElementById('loading-area').style.display = 'block'; 
    var usedfor = "english"; if(param === 'IDN') { usedfor = "indonesia"; }
    var datatext ='{"course_docid":"'+valId+'","is_featured":"'+isFeatured+'","form_id":"form-featured"}';
    var data = JSON.parse(datatext); 
    var urlFetch = global.config.urlLink+"/courseedit";
    fetch(urlFetch, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
        }).then(res => {
            if(res.status === 200) return res.json() 
        }).then( resJson => {
            document.getElementById('loading-area').style.display = 'none'; 
            if(resJson.status === '200') {
              window.location.href=global.config.urlCms+"/"+this.state.activelink+"/"+usedfor;
            } else {
                console.log('Something happened wrong');
            }
        }).catch(err => { 
            document.getElementById('loading-area').style.display = 'none'; 
        });
  }
  urldeleteCourse(valId,param) {
    var usedfor = "english"; if(param === 'IDN') { usedfor = "indonesia"; }
    var stat = false;
    stat = window.confirm("Are you sure you want to delete this data?");
    if(stat === true) {
      document.getElementById('loading-area').style.display = 'block'; 
      var urlString = global.config.urlLink+"/coursedelete";
      var datatext ='{"docid":"'+valId+'","numchild":1,"childlevel":0}';
      var data = JSON.parse(datatext); 
      fetch(urlString, {
          //method: 'DELETE',
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
      }).then(res => {
        if(res.status === 200) 
            return res.json() 
      }).then( resJson => {
          document.getElementById('loading-area').style.display = 'none'; 
          if(resJson.status === "200") {
              window.location.href=global.config.urlCms+"/"+this.state.activelink+"/"+usedfor;
              // window.location.reload();
              //window.location.href='/listevent';
          } else {
              console.log('Something happened wrong delete');
          }
      }).catch(err => {
        document.getElementById('loading-area').style.display = 'none'; 
        console.log(err);
      });
    }
  }
  loadContent = (usedfor,keyword,pageshow) => {
    return new Promise((resolve) => {
      // var langz = "English";
      // if(usedfor === "indonesia") { langz = "Indonesian"; } 
      // var datatext ='{"keyword":"'+keyword+'","pageShow":"'+pageshow+'","lang":"'+langz+'"}';
      var datatext ='{"keyword":"'+keyword+'","pageShow":"'+pageshow+'"}';
      var data = JSON.parse(datatext); 
      fetch(global.config.urlLink+"/courselist", {
          method: 'POST',
          //mode: 'no-cors', 
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin': '*',
              'Authorization': authKey,
          }, body : JSON.stringify(data)
      }).then(response => {
          if(response.status === 200) {
              return response.json()
          } else {
              console.log('Something happened wrong');
          }
      }).then(resJson => {
          // document.getElementById('loading-area').style.display = 'none'; 
          //resJson = '{status: 200, values: { userEmail: "melia@point-star.com",userFullname: "Melia",userId: "111773733087018575892",userLevel: "Admin",userName: "melia@point-star.com",userPassword: ""}}';
          // this.setState({
          //     data: resJson
          // })
          
          var resultList = resJson.values.sort((a, b) => b.content.courseDate._seconds - a.content.courseDate._seconds);
          var resultID = resultList.filter((list) =>  {
            return list.content.courseLanguage === "Indonesian" && list.content.status !== global.config.courseStatus[3];
          });
          var resultEN = resultList.filter((list2) =>  {
            return list2.content.courseLanguage === "English" && list2.content.status !== global.config.courseStatus[3]; 
          });
          
          resolve({
            "ENG": resultEN,
            "IDN": resultID
          })
          // resolve(resJson);
      }).catch(err => {
          // document.getElementById('loading-area').style.display = 'none'; 
          console.log(err);
          resolve({"status": "500"});
          
      });
    })
  }
  async loadData () {
    document.getElementById('loading-area').style.display = 'block'; 
    // var [result1, result2] = await Promise.all([this.loadContent("english",this.state.keyword,this.state.pageShow), this.loadContent("indonesia",this.state.keyword,this.state.pageShow)]);
    // this.setState({
    //         data: {
    //           "ENG": result1,
    //           "IDN": result2
    //         }
    //     })
    var [result1] = await Promise.all([this.loadContent("",this.state.keyword,this.state.pageShow)]);
    this.setState({
              data: result1
          })
    if(result1) { document.getElementById('loading-area').style.display = 'none'; }
  }
  

  componentDidMount() {
    var urlpath = window.location.pathname;
    if(urlpath.substring(urlpath.length-1,urlpath.length) === "/") {
      urlpath = urlpath.substring(0,urlpath.length-1);
    }
    var arrUrl = urlpath.split("/");
    
    var tabKey="", tabKey2="";
    if(arrUrl.length===3 && arrUrl[arrUrl.length-1] !== "") {
      tabKey = arrUrl[arrUrl.length-1];
      tabKey2 = arrUrl[arrUrl.length];
    } else if(arrUrl.length===4 && arrUrl[arrUrl.length-1] !== "") {
        tabKey = arrUrl[arrUrl.length-2];
        tabKey2 = arrUrl[arrUrl.length-1];
    }
    
    // var url = window.location.href;
    // var arrUrl = url.split("/");
    // // var tabKey = url.substring(url.lastIndexOf('/') + 1);
    // var tabKey = arrUrl[arrUrl.length-1];
    // if(tabKey === "") {
    //   tabKey = arrUrl[arrUrl.length-2];
    // }

    var usageFor = 'english'
    var defindex = "tab-1";
    if(tabKey2 !== undefined && tabKey2 !== "" && tabKey2.toLowerCase() === "indonesia") { defindex = "tab-2"; usageFor = "indonesia"; }

    this.setState({
      activelink: tabKey,
      defTabIndex: defindex,
      usageFor: usageFor
    });
    this.loadData();
  }

  contentTabs(param) {
    var statedata = this.state.data[param];

    // var stLabel = "English"; if(param === 'IDN') { stLabel = "Indonesia"; }
    var courseList = [];
    if(statedata.length > 0) {
      for(var ls=0; ls < statedata.length; ls++) {
          var retResult = statedata[ls];
          var editURL = global.config.urlCms+"/"+this.state.activelink+"/detailedit/"+retResult.docid;
          var viewURL = global.config.urlCms+"/"+this.state.activelink+"/view/"+retResult.docid;
          var iconPub = <FaToggleOff style={{color:"#999999"}} className="styleicons" onClick={this.urlpublishCourse.bind(this, retResult.docid, global.config.courseStatus[1],param)}/>;
          if(retResult.content.status === global.config.courseStatus[1] ) { iconPub =  <FaToggleOn className="styleicons" onClick={this.urlpublishCourse.bind(this, retResult.docid, global.config.courseStatus[2],param)}/> }
          var iconFeatured = <FaRegStar style={{color:"#999999"}} className="styleicons" onClick={this.urlfeaturedCourse.bind(this, retResult.docid, 1,param)}/>;
          if(retResult.content.isFeatured === "1") { iconFeatured =  <FaStar className="styleicons" onClick={this.urlfeaturedCourse.bind(this, retResult.docid, 0,param)}/> }
          // if(resultContent.courseDate !== undefined && resultContent.courseDate !== "") { 
          //   crsDate = DateTimeFormats(resultContent.courseDate._seconds,"date-long");
          // }
          courseList.push(<tr key={retResult.docid}>
              <th scope="row" className="text-center">{ls+1}</th>
              <td>{parse(ReplaceOutputTextHTML(retResult.content.courseTitle))}</td>
              <td>{retResult.content.categoryName}<br/><FaChevronRight  style={{color:"#999999",height: "15px", width: "15px", marginTop: "-4px"}}/>{retResult.content.subcategoryName}</td>
              <td>{(retResult.content.courseDate !== undefined && retResult.content.courseDate !== "") ? DateTimeFormats(retResult.content.courseDate._seconds,"date-short"):<></>}</td>
              <td>
              {retResult.content.status !== global.config.courseStatus[3]? 
                <div className="d-flex flex-row">
                  {iconFeatured}
                  <a href={editURL}><FaPen className="styleicons" title="edit" /></a>
                  <a href={viewURL}><FaFileLines className="styleicons" title="view" /></a>
                  {iconPub}
                  <FaTrash className="styleicons" aria-label="delete" onClick={this.urlpublishCourse.bind(this, retResult.docid, global.config.courseStatus[3],param)} />
                </div>
              : 
                <div className="d-flex flex-row">
                  <FaRegStar style={{color:"#999999"}} className="styleicons" />
                  <FaPen style={{color:"#999999"}} className="styleicons" title="edit" /> 
                  <a href={viewURL}><FaFileLines className="styleicons" title="view" /></a>
                  <FaToggleOff style={{color:"#999999"}} className="styleicons" />
                  <FaTrash style={{color:"#999999"}} className="styleicons" aria-label="delete" /> 
                </div>
              }
              </td>
            </tr>)
        }
    } else {
      courseList.push(<tr key="1">
            <th scope="row"></th>
            <td className="d-flex p-3">- no data -</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>)
    }
    
    return(<div>
              <div className="row show">
                  <div className="col-6"></div>
                  <div className="col-6 d-flex justify-content-end">
                      <Button variant="secondary" size="sm" onClick={this.urladdCourse.bind(this, this.state.activelink, param.toLowerCase(),'','Add')}><FaPlus style={{color:"#FFFFFF", size: "20px"}} className="me-2" />Add Workshop</Button>
                  </div>
              </div>
              <div className="mt-3">
                  <table className="table">
                    <thead className="table-dark">
                      <tr key="0">
                      <th width="50" className="text-center" scope="col">#</th>
                      <th scope="col">Title</th>
                      <th scope="col" width="230">Category</th>
                      <th scope="col" width="120">Date</th>
                      <th width="230" scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                        {courseList}
                    </tbody>
                  </table>
              </div>
           </div>
    )
    
  }  

  render() {
    // console.log(this.state.activelink);
   
    return (
      <div className="setting">
       <Container>
        {
          (localStorage.getItem("ulvl") === global.config.userLevel[0] || localStorage.getItem("ulvl") === global.config.userLevel[2])? 
          (<>
            <div className="row py-5 mb-5">
              {/* === start - body */}
                <div className="col-md-3 bg-light">
                  { 
                    this.state.activelink !== "none" && 
                      <MenuLeftCMS value={{tabkey:this.state.activelink}}/>
                  
                  }
                </div>
                <div className="col-md-9 p-4">
                  <div className="row">
                    <div>
                      <h3>{GetText() ? "Workshop" : "Workshop"}</h3>
                      <span className="text-muted">{GetText() ? "Daftar Workshop" : "List of Workshop"}</span>
                    </div>
                    <div className="mt-3">
                    {
                      this.state.defTabIndex !== "" && 
                        <Tabs className="nav-scroll" defaultActiveKey={this.state.defTabIndex} variant="tabs" id="tab">
                          <Tab className="pt-4" eventKey="tab-1" title="English" key="1">
                            <div>
                            {this.contentTabs("ENG")}
                            </div>
                          </Tab>
                          <Tab className="pt-4" eventKey="tab-2" title="Indonesia" key="2">
                            {this.contentTabs("IDN")}
                          </Tab>

                      </Tabs>
                    }
                    </div>
                  </div>
                </div>
              {/* === end - body */}
            </div>
            
            </>
          )
        : 
          <div><CTNA/></div>
        }
        <div id="loading-area" className="d-none loading"></div> 
        </Container>
      </div>
    );
  }
}
